import React from 'react';
import maria from '../../../assets/maria-maj-kowal.png';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

const Welcome = () => {
    return (
        <section className="welcome">
            <div className="container">
                <div className="welcome__text-box">
                    <p className="welcome__text">
                        <h1 className="welcome__name">Po Zdrowie</h1> to miejsce, w&nbsp;którym znajdą Państwo kompleksowe i&nbsp;profesjonalne zabiegi&nbsp;fizjoterapeutyczne.<br />
                        Przyjdź po zdrowie!
                        <span className="welcome__subtext">Zapraszam, Maria Maj-Kowal</span>
                    </p>
                </div>
                <div className="welcome__image-box">
                    <LazyLoadImage effect="blur" className="welcome__image" src={maria} alt="Maria Maj-Kowal zdjęcie" width="400" height="400" />
                </div>
            </div>
        </section>
    );
}

export default Welcome;